import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { StoreModel } from 'src/app/models/archive/store.model';
import { StoreImportModel } from 'src/app/models/imports/store-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(private _httpClient: HttpClient) { }

  createStore(storeContractModel: StoreModel): Observable<StoreModel> {
    return this._httpClient.post<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.CreateStore}`,
      storeContractModel);
  }

  deleteStore(storeId: number): Observable<StoreModel> {
    return this._httpClient.delete<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.DeleteStore}/${storeId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.store.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllInventoriesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllInventoriesForSelectAsync}`,);
  }

  getAllStoresWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllStoresWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllStoreActivesByBranchInventory(branchId: number, inventoryId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllStoreActivesByBranchInventory}/${branchId}/${inventoryId}`);
  }

  getAllStoreByBranchInventory(branchId: number, inventoryId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllStoreByBranchInventory}/${branchId}/${inventoryId}`);
  }

  getAllStoresForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllStoresForSelectAsync}`,);
  }

  getAllStoresByBranchForSelectAsync(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllStoresByBranchForSelectAsync}`,
      { params: params }
    );
  }

  getAllStoresWithoutSubrentalForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllStoresWithoutSubrentalForSelect}`,);
  }

  getAllSubrentalStoresForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetAllSubrentalStoresForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetColumnsForGeneralConsultationAsync}`);
  }

  getDefaultStoreIdByBranch(branchId: number): Observable<number | null> {
    return this._httpClient.get<number | null>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetDefaultStoreIdByBranch}/${branchId}`)
  }

  getFirstStoreByKeysAsync(branchId: number): Observable<StoreModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetFirstStoreByKeysAsync}`,
      { params: params }
    );
  }

  getLastStoreByKeysAsync(branchId: number): Observable<StoreModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetLastStoreByKeysAsync}`,
      { params: params }
    );
  }

  getNextStoreByKeysAsync(branchId: number, code: number): Observable<StoreModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetNextStoreByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusStoreByKeysAsync(branchId: number, code: number): Observable<StoreModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetPreviusStoreByKeysAsync}`,
      { params: params }
    );
  }

  getStoreByCode(branchId: number, code: number): Observable<StoreModel> {
    return this._httpClient.get<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoreByCode}/${branchId}/${code}`)
  }

  getStoreById(storeId: number): Observable<StoreModel> {
    return this._httpClient.get<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoreById}/${storeId}`);
  }

  getStoresActivesByBranchInventoryForSelect(branchId: number, inventoryId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoresActivesByBranchInventoryForSelect}/${branchId}/${inventoryId}`);
  }

  getStoresByBranchId(branchId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoresByBranchId}/${branchId}`);
  }

  GetStoresForInvoice(branchId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoresForInvoice}/${branchId}`);
  }

  getStoresForNotes(invoiceId: number, conceptInvoicingId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoresForNote}/${invoiceId}/${conceptInvoicingId}`);
  }

  getStoresRentalByBranchId(branchId: number): Observable<Array<StoreModel>> {
    return this._httpClient.get<Array<StoreModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.GetStoresRentalByBranchId}/${branchId}`);
  }

  importProviders(storeImports: Array<StoreImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.ImportStores}`, storeImports);
  }

  setActiveStore(storeId: number): Observable<StoreModel> {
    return this._httpClient.put<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.SetActiveStore}/${storeId}`,
      null);
  }

  updateStore(storeContractModel: StoreModel): Observable<StoreModel> {
    return this._httpClient.put<StoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.store.UpdateStore}`,
      storeContractModel);
  }
}
